import { controls, grouped } from "../controls";
const transfer_batches = {
  label: "Transfer Transaction",
  pageLabel: "Transfer Transaction", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false }, open: { allow: false } },
  pageType: "history",
  isTransaction: true,
  filter: [
  ]
  , form: [

    ...grouped.trnsummary(),

    {
      widths: "col-sm-9",
      tab: "general",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          tab: "general",
          title: "Transfer Transactions",
          subComponents: [

            {
              widths: "col-sm-12",
              tab: "general",
              fastpath: "transfer_transactions",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [

                ...controls.displayText({ tab: "general", label: "", star: true }),
                ...controls.radio({
                  tab: "general", name: "is_credit", width: "col-sm-3", options: [
                    { label: "Debit", value: false },
                    { label: "Credit", value: true },
                  ]
                }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-7" }),


                ...controls.displayText({ tab: "general", label: "Account", star: true, parents: [{ "name": "close_account", "match": "exist", "reverse": "true", "show": "readonly" }] }),
                ...controls.oc({
                  tab: "general", c: "Account", placeHolder: "Account Code", width: 'col-sm-3', name: "account_code", fastpath: "accounts",
                  parents: [{ "name": "close_account", "match": "exist", "reverse": "true", "show": "readonly" }],
                  liveValidation: ["amount"], clearData: ["amount", "charges", "interest", "penal", "instrument_number", "close_account", "sys_checkbox_close_account", "inst_date"], displayData: { account_display: "account_display", account_uid: "account_uid", gender: "gender", pan: "pan", aadhaar: "aadhaar", mothers_name: "mothers_name", customer_code: "customer_number", religion: "religion", caste: "caste", mobile: "mobile", dob: "dob", customer_type: "customer_type", int_rate: "int_rate", open_date: "open_date", balance: "balance", prin_int: "prin_int", interest: "interest", penal: "charges", min_balance: "min_balance", expiry_date: "expiry_date", maturity_amount: "maturity_amount", close_date: "close_date", kyc_update_date: "kyc_update_date", fd_amount: "fd_amount", interest_date: "last_int_date", principal_balance: "principal_balance", principalized_interest: "principalized_interest", interest_pending: "interest_pending", charges_pending: "charges_pending", penal_pending: "penal_pending" },
                  sendToServer: { sendData: [{ varname: 'is_credit', value: 'is_credit' }] }

                }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "account_display", parents: [{ "name": "close_account", "match": "exist", "reverse": "true", "show": "readonly" }], width: "col-sm-7" }),
                ...controls.displayText({ tab: "general", label: "Amount", star: true, parents: [{ "name": "close_account", "match": "exist", "reverse": "true", "show": "readonly" }] }),
                ...controls.numtoword({ tab: "general", placeHolder: "", name: "amount", maxlength: 18, parents: [{ "name": "close_account", "match": "exist", "reverse": "true", "show": "readonly" }], width: 'col-sm-3', textwidth: "col-sm-7", liveValidation: ["account_code"] }),
                ...controls.displayText({ tab: "general", label: "Charges" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "charges", width: 'col-sm-3', maxlength: 18 }),
                ...controls.displayText({ tab: "general", label: "Interest", width: 'col-sm-1' }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "interest", maxlength: 18, isReadOnly: true }),
                ...controls.displayText({ tab: "general", label: "Penal", width: 'col-sm-1' }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "penal", maxlength: 18, isReadOnly: true }),
                ...controls.displayText({ tab: "general", label: "Instru Number", star: false }),
                ...controls.text({ tab: "general", placeHolder: "", name: "instrument_number", maxlength: 10, width: "col-sm-3" }),
                ...controls.magicDateLabel({ tab: "general", label: "Instru Date", target: "inst_date", star: false, width: 'col-sm-1' }),
                ...controls.magicDate({ tab: "general", name: "inst_date", dateType: "ontype", isReadOnly: "edit" }),
                ...controls.checkBox({ tab: "general", width: "col-sm-4", label: "Close Account", default: false, name: "close_account", parents: [{ "name": "sys_checkbox_close_account", "match": "exist", "show": "readonly" }], isReadOnly: "edit", sendToServer: { sendData: ["account_code"], dataType: "serverfunc", func: "closingAmounts" }, displayData: { interest: "interest", penal_interest: "penal", amount: "amount" }, clearData: ["interest", "penal", "amount"] }),

                // ...controls.radio({ tab: "general", label: "Credit", default: false, name: "is_credit", isReadOnly: "edit" }),




                ...controls.displayText({ tab: "general", label: "Particulars", star: true }),
                ...controls.text({ tab: "general", placeHolder: "", name: "particulars", maxlength: 10, width: 'col-sm-6', defaultValue: "By cash", next_field: "add_to_grid" }),
                ...controls.displayText({ tab: "transfer_transactions", width: "col-sm-12", label: "" }),
                ...controls.displayText({ tab: "transfer_transactions", width: "col-sm-4", label: "" }),
                ...controls.button({
                  tab: "transfer_transactions",
                  label: "ADD",
                  style: { padding: 0 },
                  Bcolor: "success",
                  onclick: {
                    action: "appendToHTMLTable",
                    tableNameField: "transfer_transactions",
                    requiredField: ["account_code", "account_display", "account_uid", "amount", "charges", "interest", "penal", "instrument_number", "inst_date", "close_account", "is_credit", "particulars",],
                    required: ["account_code", "account_display", "account_uid", "amount", "particulars",],
                    removeAlso: ["sys_checkbox_close_account"],
                  }, width: "col-sm-2"
                }),
                ...controls.button({
                  tab: "transfer_transactions",
                  label: "CLEAR",
                  style: { padding: 0 },
                  Bcolor: "warning",
                  onclick: {
                    action: "clearForm",
                    tableNameField: "transfer_transactions",
                    requiredField: ["account_code", "account_display", "account_uid", "amount", "charges", "interest", "penal", "instrument_number", "inst_date", "close_account", "is_credit", "particulars",]
                  }, width: "col-sm-2"
                }),
              ]
            }, {
              tab: "transfer_transactions",
              inputType: "table",
              tableTitle: "",
              deletable: true,
              editable: true,
              tableHeaders: [
                { label: "Sr", type: "autoinc" },
                { label: "Account Code", field: "account_code" },
                { label: "Account ", field: "account_display" },
                { label: "Amount", field: "amount" },
                { label: "Charges", field: "charges" },
                { label: "Interest", field: "interest" },
                { label: "Penal", field: "penal" },
                { label: "Instru Number", field: "instrument_number" },
                { label: "Instru Date", field: "inst_date", displaytype: "date" },
                { label: "Close Account", field: "close_account", displaytype: "tick" },
                { label: "Credit", field: "is_credit", displaytype: "tick" },
                { label: "Particulars", field: "particulars" },
              ],
              widths: {
                parent: "col-sm-12",
                children: "col-sm-12"
              },
              name: "transfer_transactions",
              onRender: [
                { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.transfer_transactions', field: 'amount', filter: { is_credit: true } }, resultVar: 'totalCredit' },
                { f: 'setParentState', inputs: { dest: "pageData.total_credit", source: 'allResults', field: 'totalCredit' }, resultVar: "totalCreditT" },
                { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.transfer_transactions', field: 'amount', filter: { is_credit: false } }, resultVar: 'totalDebit' },
                { f: 'setParentState', inputs: { dest: "pageData.total_debit", source: 'allResults', field: 'totalDebit' }, resultVar: "totalDebitT" },
                { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalCredit' }, { source: 'allResults', field: 'totalDebit', mult: { source: "fixed", val: -1 } }], resultVar: 'difference' },
                { f: 'setParentState', inputs: { dest: "pageData.final_amount", source: 'allResults', field: 'difference' }, resultVar: "totalDebitT" },
              ],
            },
          ]
        },

      ]
    }, grouped.acinfo('general')]
  , history: {
    perPage: 10,
    reportHeader: "Transfer Transaction",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Updatedat", accessor: "updatedat", type: 'date' },
      { Header: "Total Credits", accessor: "total_credits", },
      { Header: "Batch Number", accessor: "batch_number", },
      { Header: "Is Auth", accessor: "is_auth", type: 'tick' },
      { Header: "Is Reverted", accessor: "is_reverted", type: 'tick' },
    ]
  }
};
export default transfer_batches;